import React, { useContext,useState } from "react";


import { ConfigContext } from "../context/GlobalContext";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VoiceButton from "../components/VoiceButton";



const ReportPage = ({ }) => {
  const { state ,dispatch } = useContext(ConfigContext);

  const [lang, setLang] = useState('en-US');

  return (
    <>
     <div className="p-4">
      <label>Select Language: </label>
      <select onChange={(e) => setLang(e.target.value)} value={lang}>
        <option value="en-US">English (US)</option>
      </select>

      <VoiceButton language={lang} />
    </div>
    </>

  );
};

export default ReportPage;
